/**
 * Token store with sessionStorage persistence for page-refresh resilience.
 * 
 * On page refresh, in-memory tokens are lost. httpOnly cookies should handle auth,
 * but on mobile browsers where cookies may be blocked/delayed, we need a fallback.
 * 
 * Uses sessionStorage (cleared when tab closes, not shared across tabs) as a
 * middle ground between security (no localStorage XSS exposure across tabs)
 * and usability (survives same-tab refreshes).
 */

let _accessToken = null;

// Restore token from sessionStorage on module init (survives page refresh)
try {
  const stored = sessionStorage.getItem('_at');
  if (stored) _accessToken = stored;
} catch (_) {
  // sessionStorage unavailable (private browsing, etc.)
}

export const setAccessToken = (token) => {
  _accessToken = token;
  try {
    if (token) {
      sessionStorage.setItem('_at', token);
    } else {
      sessionStorage.removeItem('_at');
    }
  } catch (_) {}
};

export const getAccessToken = () => _accessToken;

export const clearAccessToken = () => {
  _accessToken = null;
  try { sessionStorage.removeItem('_at'); } catch (_) {}
};

/**
 * Detect if the browser likely blocks third-party cookies (Safari ITP).
 * Used to decide whether to include Authorization header as fallback.
 */
export const needsTokenFallback = () => {
  return !!_accessToken;
};
